module.exports = __webpack_public_path__ + "img/Frame_StageFrame_n_Purple.1cebb0bc.png";